import {IoCart} from 'react-icons/io5';

function CartWidget() {
    return (
        <div>
            <IoCart />
        </div>
    )
}

export default CartWidget
